import { config } from '@app/config';

interface DefineHostWithProtocolParams {
  isWebSocket?: boolean;
  isBookHost?: boolean;
}

export const defineHostWithProtocol = ({
  isWebSocket = false,
  isBookHost = false,
}: DefineHostWithProtocolParams): string => {
  const { websocketHost, restHost, restBookHost } = config.backendHosts;

  return isWebSocket ? websocketHost : isBookHost ? restBookHost : restHost;
};
